import { shutdownCopy } from './confetti';
import './TechnicalIssues.css';

const TechnicalIssues = ({ event }) => {
  const copy = shutdownCopy(event);

  return (
    <div className="technical-issues" role="alert">
      <div className="technical-issues-card">
        <svg className="tech-gear" viewBox="0 0 64 64" aria-hidden="true">
          <path
            fill="currentColor"
            d="M36.2 4h-8.4l-1.6 6.3a22 22 0 0 0-5 2.1L15.6 9.2 9.2 15.6l3.2 5.6a22 22 0 0 0-2.1 5L4 27.8v8.4l6.3 1.6a22 22 0 0 0 2.1 5l-3.2 5.6 6.4 6.4 5.6-3.2a22 22 0 0 0 5 2.1l1.6 6.3h8.4l1.6-6.3a22 22 0 0 0 5-2.1l5.6 3.2 6.4-6.4-3.2-5.6a22 22 0 0 0 2.1-5L60 36.2v-8.4l-6.3-1.6a22 22 0 0 0-2.1-5l3.2-5.6-6.4-6.4-5.6 3.2a22 22 0 0 0-5-2.1L36.2 4z"
          />
          <circle cx="32" cy="32" r="8" className="tech-gear-hole" />
        </svg>
        <h1>{copy.title}</h1>
        <p>{copy.message}</p>
      </div>
    </div>
  );
};

export default TechnicalIssues;
